import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ProfileIcon } from '../../images/icons/person.svg';
// import {ReactComponent as EditIcon} from '../../images/icons/edit.svg';
import EditTeamMemberModal from './EditMemberModal';

class TeamMemberCard extends Component {
    constructor (props) {
        super(props);

        this.state = {
            editTeamMemberModalOpen: false,
            teamMemberDetailsOpen: false,
        };
    }

    toggleEditTeamMemberModal = () => {
        const { editTeamMemberModalOpen } = this.state;
        editTeamMemberModalOpen
            ? this.setState({
                editTeamMemberModalOpen: false,
            })
            : this.setState({
                editTeamMemberModalOpen: true,
            });
    };

    toggleTeamMemberDetails = () => {
        const { teamMemberDetailsOpen } = this.state;
        teamMemberDetailsOpen
            ? this.setState({
                teamMemberDetailsOpen: false,
            })
            : this.setState({
                teamMemberDetailsOpen: true,
            });
    };

    render () {
        const { editTeamMemberModalOpen, teamMemberDetailsOpen } = this.state;
        return (
            <div className="team-member-card">
                <div className="team-member-card-top">
                    <div className="team-member-card-left">
                        {this.props.avatar ? (
                            <img
                                className="team-member-card-profile-img"
                                src={this.props.avatar}
                                alt="user-profile-avatar"
                            />
                        ) : (
                            <div className="team-member-card-profile-img-placeholder">
                                <ProfileIcon />
                            </div>
                        )}
                    </div>
                    <div className="team-member-card-right">
                        <p className="tm-card-name">{this.props.name}</p>
                        <div className="tm-card-btns">
                            <p onClick={this.toggleTeamMemberDetails}>
                                {teamMemberDetailsOpen ? 'Hide ' : 'View '}
                                details
                            </p>
                            {/* <p className="bullet">•</p>
                            <p onClick={this.toggleEditTeamMemberModal}>Edit</p> */}
                        </div>
                        {/* { this.props.role && <p className="tm-card-role">{this.props.role}</p>} */}
                        {/* <div className="team-member-card-priorities">
                            <p className="tm-card-priority">Editing</p>
                            <p className="tm-card-priority">Replying</p>
                        </div> */}
                    </div>
                </div>
                {teamMemberDetailsOpen && (
                    <div className="team-member-card-bottom">
                        <p className="tm-card-extra-details">
                            <span className="tm-card-label">Email:</span> {this.props.email}
                        </p>
                        {this.props.role && (
                            <p className="tm-card-extra-details">
                                <span className="tm-card-label">Role:</span> {this.props.role}
                            </p>
                        )}
                    </div>
                )}
                {editTeamMemberModalOpen && <EditTeamMemberModal toggleModal={this.toggleEditTeamMemberModal} />}
            </div>
        );
    }
}

TeamMemberCard.propTypes = {
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    avatar: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
};

TeamMemberCard.defaultProps = {
    name: '',
    email: '',
    avatar: '',
    role: '',
};

export default TeamMemberCard;
